import {createSelector} from 'reselect';
import {getAppState} from './appStateSelector';

const getManageEmployeeState = (state) => state.manageEmployeeState;

export const modalCreateUpdateEmployeeStateSelector = createSelector(
  [getManageEmployeeState, getAppState],
  (manageEmployeeState, appState) => ({
    departments: manageEmployeeState?.departments,
    companies: manageEmployeeState?.companies,
    authRoles: manageEmployeeState?.authRoles,
    roleLevels: manageEmployeeState?.roleLevels,
    practices: manageEmployeeState?.practices,
    show: manageEmployeeState?.show,
    modalType: manageEmployeeState?.modalType,
    newEmployee: manageEmployeeState?.newEmployee,
    userAuthRoleId: appState.user?.authRole?.id,
    userDeptId: appState?.user?.departmentID,
    currentPeriodId: appState?.currentPeriod?.id,
  })
);

export const tableEmployeeStateSelector = createSelector([getManageEmployeeState], (manageEmployeeState) => ({
  employees: manageEmployeeState?.employees,
  sortValue: manageEmployeeState?.sortValue,
  filterMap: manageEmployeeState?.filterMap,
  pageIndex: manageEmployeeState?.pageIndex,
  pageSize: manageEmployeeState?.pageSize,
  pageNo: manageEmployeeState?.pageNo,
  totalItem: manageEmployeeState?.totalItem,
  responseStatus: manageEmployeeState?.responseStatus,
  selectedTab: manageEmployeeState?.selectedTab,
}));

export const manageEmployeeSelector = createSelector([getManageEmployeeState, getAppState], (manageEmployeeState, appState) => ({
  isManageEmployeeStateNull: manageEmployeeState === null,
  selectedTab: manageEmployeeState?.selectedTab,
  isSavingReviewState: appState?.isSavingReview,
}));
